import script from "./RoundCountdown.vue?vue&type=script&setup=true&lang=js"
export * from "./RoundCountdown.vue?vue&type=script&setup=true&lang=js"

import "./RoundCountdown.vue?vue&type=style&index=0&id=7af8c981&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7af8c981"]])

export default __exports__